module.exports = __webpack_public_path__ + "bouncer-de1ec4f00b5444c5d318.jpg";